import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { DefaultLink, FakeLink } from '@hivebrite/design-system/Link';

import Modal from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import HtmlContent from 'hb-react/shared/components/HtmlContent';

const Content = ({ content, text, type }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (type === 'link') {
    return (
      <DefaultLink target="_blank" href={content}>
        {text}
      </DefaultLink>
    );
  }

  return (
    <>
      <FakeLink as="a" display="inline-flex" onClick={() => setIsOpen(true)}>
        {text}
      </FakeLink>
      {isOpen && (
        <Modal
          onCloseModal={() => setIsOpen(false)}
          header={text}
          screenReadersCloseButtonText={s__(
            'TermsAndPolicyAccessibility|Close the %{text} dialog',
          ).i__({ text })}
        >
          <HtmlContent content={content} stylesConfig="web" />
        </Modal>
      )}
    </>
  );
};

const LoginTermsAndPolicy = ({ settings }) => {
  const { enabled, policies, terms } = settings;

  return enabled && (terms.enabled || policies.enabled) ? (
    <Box mb={2} mt={7} as="span" display="inline-block">
      {`${__('By logging to your account, you agree to the')} `}
      {terms.enabled && (
        <Content text={s__('TermsAndPolicy|Terms of Use')} {...terms} />
      )}
      {terms.enabled && policies.enabled && ` ${__('and')} `}
      {policies.enabled && (
        <Content text={s__('TermsAndPolicy|Privacy Policy')} {...policies} />
      )}
    </Box>
  ) : null;
};

export default LoginTermsAndPolicy;
